/* Keep page content clear of the fixed mobile Menu/Cart bar, whatever height it actually renders at (fixes the promo bar getting clipped underneath it). */
(function () {
  function adjustMobileNavOffset() {
    var bar = document.getElementById('mobileNavBar');
    if (!bar) { return; }
    var isFixed = window.getComputedStyle(bar).position === 'fixed';
    document.body.style.paddingTop = isFixed ? bar.offsetHeight + 'px' : '';
  }

  window.addEventListener('load', adjustMobileNavOffset);
  window.addEventListener('resize', adjustMobileNavOffset);
  document.addEventListener('click', function (evt) {
    if (evt.target.closest && evt.target.closest('.menu-toggle')) {
      setTimeout(adjustMobileNavOffset, 0);
      setTimeout(adjustMobileNavOffset, 300);
    }
  });

  document.addEventListener('DOMContentLoaded', adjustMobileNavOffset);
})();

/* Keep the main menu's hover dropdowns inside the window.

   The base theme positions every dropdown with "position: absolute; left: 0"
   against its parent menu item, so a dropdown always opens rightwards from
   the left edge of that item. Fine on the left of the bar, but the items near
   the right-hand end (Tools, plus others once the window is narrower) have
   dropdowns wider than the space remaining, so they ran off the side of the
   page and their links were unreadable.

   This flips only the affected dropdowns to open leftwards instead - right
   edge lined up with the right edge of their menu item - which is what a menu
   is normally expected to do at the end of a bar. It has to be done in JS
   because which items overflow depends on the window width and on each
   dropdown's own width (they range from ~230px to ~500px here), so there is
   no fixed set of items that could be hard-coded in CSS.

   Safe to measure at any time: the theme hides dropdowns with
   visibility/opacity rather than display:none, so they are always laid out
   and offsetWidth is real even while hidden. Inline styles are used so they
   beat the stylesheet's left: 0 without needing !important. */
(function () {
  var GUTTER = 10;
  var DESKTOP_MIN = 769;

  function place(li) {
    var dd = li.querySelector('.site-nav--dropdown');
    if (!dd) { return; }

    dd.style.left = '';
    dd.style.right = '';

    if (window.innerWidth < DESKTOP_MIN) { return; }

    var rect = li.getBoundingClientRect();
    var width = dd.offsetWidth;

    if (rect.left + width > window.innerWidth - GUTTER) {
      if (rect.right - width >= GUTTER) {
        dd.style.left = 'auto';
        dd.style.right = '0';
      }
    }
  }

  function placeAll() {
    var items = document.querySelectorAll('.nav-bar .site-nav--has-dropdown');
    for (var i = 0; i < items.length; i++) { place(items[i]); }
  }

  var pending;
  function placeAllSoon() {
    clearTimeout(pending);
    pending = setTimeout(placeAll, 100);
  }

  document.addEventListener('DOMContentLoaded', placeAll);
  window.addEventListener('load', placeAll);
  window.addEventListener('resize', placeAllSoon);

  document.addEventListener('mouseover', function (evt) {
    if (!evt.target.closest) { return; }
    var li = evt.target.closest('.nav-bar .site-nav--has-dropdown');
    if (li) { place(li); }
  });
})();
